import { HttpClient, JSON_STRING, clientName, baseUrl, MHTTPCL, batchServer } from "../../../services/http/http-client";
import { HttpLib } from "../../../services/http/http-lib";
import * as querystring from 'qs';
import { MODIFICATION_URL } from "../../booking/services/booking-service";
import { CONTACTS_URL } from "../../contacts/services/contact_groups.service";
import { combineServiceMethods } from "../../../global/service";
import { format } from 'date-fns';

export const ACCOUNTING_URL = '/accounting.pl';

export const InvoicesService = {
  findInvoiceData: () => HttpClient.get(ACCOUNTING_URL, {
    section: 'invoices',
    output: JSON_STRING
  }),
  findAllInvoices: () => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'all_invoices',
    output: JSON_STRING
  }),
  searchInvoices: ({
    search_str,
    invoiceStatuses = '',
    invoice_project_id = 0,
    invoice_user_id = 0,
  }, options) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'filter_invoice_json',
    search_str,
    invoiceStatuses,
    invoice_project_id,
    invoice_user_id,
  }, options),
  searchScollInvoices: ({
    searchString = '',
    invoiceStatuses = '',
    invoice_project_id = '',
    invoice_user_id = '',
    start = 0
  } = {}, options) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoice_scroll',
    search_str: searchString,
    invoiceStatuses,
    invoice_project_id,
    invoice_user_id,
    start_from: start
  }, options),
  advance_search: ({
    // start
    // end
    // start_payment
    // end_payment
    // status_textkeys
    // invoice_project_ids
    // subject
    // amount
    // pdf
    // invoice_ref
    // recipient
    row_start = 0,
    start = '',
    end = '',
    start_payment = '',
    end_payment = '',
    status_textkeys = '',
    invoice_project_ids = '',
    subject = '',
    amount = '',
    pdf = '',
    invoice_ref = '',
    recipient = '',
  }, options) => HttpClient.get(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'advance_search',
    start,
    end,
    start_payment,
    end_payment,
    status_textkeys,
    invoice_project_ids,
    subject,
    amount,
    pdf,
    invoice_ref,
    recipient,

    row_start,
  }, options),
  getPaypalModal: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'displayPaypalPaymentMsgModal',
    invoice_id
  }),
  includePaypalOption: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'includePaypalOption',
    invoice_id
  }),
  getInvoiceReminder: ({
    invoice_id,
    output_media = '',
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoice_reminder',
    action: 'emailInvoiceDetails',
    invoice_id,
    output_media,
  }),
  lockInvoice: ({
    invoice_id,
    lock_flag = 1
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'lockUnlockInvoice',
    invoice_id,
    lock_flag
  }),
  invoiceFlagModal: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'openInvoiceFlagChangeModal',
    output: JSON_STRING,
    invoice_id
  }),
  getPaidModalInfo: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'getPaidModalInfo',
    invoice_id
  }),
  setPaidModalInfo: ({
    invoice_id,
    fullOrPartial,
    date,
    amount,
    exchangerate,
    currency_id,
    debit_credit,
    money_account_id,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'savePaidModalInfo',
    invoice_id,
    fullOrPartial,
    date,
    amount,
    exchangerate,
    currency_id,
    debit_credit,
    money_account_id,
  }),

  setBadDebt: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'setInvoiceToBadDept',
    invoice_id
  }),

  invoiceCancelDeletePreChecking: ({
    invoice_id,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoiceCancelDeletePreChecking',
    invoice_id,
  }),
  checkCurrencyRateLimit: ({
    invoice_id,
    amount,
    exchangerate,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'checkCurrencyRateLimit',
    invoice_id,
    amount,
    exchangerate,
  }),
  deletePayments: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'deleteInvoicePaymentsSetOpen',
    invoice_id
  }),
  cancelInvoiceCheck: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoiceCancelDeletePreChecking',
    invoice_id
  }),
  cancelInvoice: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'cancelInvoice',
    invoice_id
  }),
  deleteInvoice: ({
    invoice_id,
    report_lines,
    licence_lines,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'deleteInvoice',
    invoice_id,
    report_lines,
    licence_lines,
  }),
  getCreateCreditNoteInvoice: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'displayCreateCreditNoteModal',
    invoice_id
  }),
  createCreditNote: ({
    invoice_id,
    invoice_project_id,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'createInvoiceCreditNote',
    invoice_id,
    invoice_project_id,
  }),

  getInvoiceDetails: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoice_detail',
    invoice_id,
    output: JSON_STRING
  }),
  getInvoiceTabInfo: ({
    invoice_id
  }, options) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoice_tab_invoice_info',
    invoice_id,
    output: JSON_STRING
  }, options),
  getInvoiceLineData: ({
    invoice_id
  }, options) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoice_tab_invoice_lines',
    invoice_id,
    output: JSON_STRING
  }, options),

  getInvoicePaymentData: ({
    invoice_id
  }, options) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoice_tab_payments',
    invoice_id,
    output: JSON_STRING
  }, options),
  getInvoiceForwardingData: ({
    invoice_id
  }, options) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'invoice_tab_forwarding',
    invoice_id,
    output: JSON_STRING
  }, options),

  updateVatNo: ({
    contact_id,
    value,
  }) => HttpClient.post(CONTACTS_URL, {
    section: '',
    action: 'update_vat_no',
    contact_id,
    vat_no: value
  }),
  performRoyaltyDates: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'check_and_adjust_roylaty_dates',
    invoice_id
  }),
  changeTaxDeduction: ({
    invoice_id,
    vat_handling,
    tax_type_id_deduction,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'change_tax_type_deduction',
    invoice_id,
    vat_handling,
    tax_type_id_deduction,
  }),
  insertArtistPayment: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'add_artist_payment_forward',
    invoice_id
  }),
  insertAgentPayment: ({
    invoice_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'add_agent_payment_forward',
    invoice_id
  }),

  createInvoice: ({
    invoice_user_id,
    invoice_project_id,
    currency_id,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'save_invoice',
    invoice_language: 'en',
    vat_rate1: '19.00',
    vat_rate2: '7.00',
    vat_rate3: '0.00',
    invoice_date: format(new Date(), 'YYYY-MM-DD'),
    exchange_rate: '1',
    money_account_id: '1',
    payment_method_id: '1',

    invoice_user_id,
    invoice_project_id,
    currency_id,
  }),

  createNewInvoiceLine: ({
    invoice_id,
    vat_type = 1,
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'save_inoviceline',
    output: JSON_STRING,
    invoice_id,
    vat_type
  }),
  removeInvoiceLine: ({
    invoiceline_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'remove_invoiceline',
    invoiceline_id,
  }),


  // Finds mainly the Countries List
  findContactForm: ({
    makerelation = 1,
  } = {}) => HttpClient.get(CONTACTS_URL, {
    action: 'company_contact_form',
    source: 'widget',
    makerelation,
  }),
  setInvoiceContact: ({
    invoice_id,
    contact_id
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'set_item_contact',
    table: 'invoices',
    key: 'invoice_id',
    kVal: invoice_id,
    name: 'contact_id',
    value: contact_id,
    template_type: 'custom_invoice',
    contact_search_type: 'both',
    output: JSON_STRING
  }),
  findVatTerritories: (
    invoice_id
  ) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'vat_territories',
    invoice_id: invoice_id,
    start: -1
  }),
  findContactData: ({
    contact_id
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'contact_data_json',
    contact_id,
  }),

  updateInvoiceContact: ({
    invoice_id,
    invoice_address,
    contact_id,
    invoice_language = null,
    payment_method_id = null,
    vat_handling = 3,
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: 'record',
    table: 'invoices',
    kVal: invoice_id,
    invoice_address,
    contact_id,
    invoice_language,
    payment_method_id,
    vat_handling,
  }),
  insertNewContact: ({
    vat_no,
    tax_no,
    account_holder,
    iban,
    swift,
    bank_name,
    bank_address,
    bank_postalcode,
    bank_city,
    bank_country,
    intermediate_country,
    bank_routing,
    first_name,
    last_name,
    company_name,
    registration,
    company_legalname,
    legal_form,
    address1,
    address2,
    postalcode,
    city,
    region,
    country,
    email1,
    phone1,
    payment_provider_data,
    contact_type,
    new_contact_name,
  }) => HttpClient.post(CONTACTS_URL, {
    vat_no,
    tax_no,
    account_holder,
    iban,
    swift,
    bank_name,
    bank_address,
    bank_postalcode,
    bank_city,
    bank_country,
    intermediate_country,
    bank_routing,
    first_name,
    last_name,
    company_name,
    registration,
    company_legalname,
    legal_form,
    address1,
    address2,
    postalcode,
    city,
    region,
    country,
    email1,
    phone1,
    payment_provider_data,
    contact_type,
    new_contact_name,
    action: 'add_contact_believe_special',
  }),

  changeInvoiceProject: (invoice_id, invoice_project_id, payment_method_id, money_account_id, vat_rate1, vat_rate2, vat_rate3, vat_handling, tax_type_id_deduction) => MHTTPCL.post(ACCOUNTING_URL, {
    section: 'invoices',
    action: 'change_invoice_project',
    invoice_id: invoice_id,
    invoice_project_id: invoice_project_id,
    payment_method_id: payment_method_id,
    money_account_id: money_account_id,
    vat_rate1: vat_rate1,
    vat_rate2: vat_rate2,
    vat_rate3: vat_rate3,
    vat_handling: vat_handling,
    tax_type_id_deduction: tax_type_id_deduction

  }),  
  batchPDFDownload: ({
    ids,
    type,domain_tld
  }) => HttpLib.post(`https://batch.${domain_tld}/${clientName}${ACCOUNTING_URL}`,
      querystring.stringify({
        section: 'invoices',
        action: 'pdf_invoice_batch',
        ids,
        type
      }),
      {
        withCredentials: true,

      })

}


export const GetInvoiceDetails = combineServiceMethods([
  'getInvoiceTabInfo',
  'getInvoiceLineData',
  'getInvoicePaymentData',
  'getInvoiceForwardingData',
], InvoicesService);